import { useNavigate } from 'react-router-dom'
import { Cards, Link, Header, Box } from '@cloudscape-design/components'

const awsCards = [
	{
		name: 'Accounts',
		description: 'You can manage accounts here.',
		href: '/accounts'
	},
	{
		name: 'Projects',
		description: 'You can manage project creation here.',
		href: '/projects'
	},
	{
		name: 'Clusters',
		description: 'You can manage workload cluster requests here.',
		href: '/clusters'
	}
]

const gcpCards = [
	{
		name: 'Projects',
		description: 'You can manage GCP projects here.',
		href: '/gcpProjects'
	},
	{
		name: 'Clusters',
		description: 'You can manage GCP Clusters here.',
		href: '/cluster'
	},
	{
		name: 'Applications',
		description: 'You can manage GCP Applications here.',
		href: '/applications'
	},
	{
		name: 'Microservices',
		description: 'You can manage your microservices here.',
		href: '/microservices'
	},
	{
		name: 'APIs',
		description: 'You can manage your APIs here.',
		href: '/apis'
	},
]

const rhocpCards = [
	{
		name: 'Tenants',
		description: 'You can manage RHOCP tenants here.',
		href: '/rhocpTenants'
	}
]

const adCards = [
	{
		name: 'Access Management',
		description: 'You can manage users and roles here.',
		href: '/access-management'
	},
	{
		name: 'Active Directory',
		description: 'You can manage Active Directory users and groups here.',
		href: '/active-directory'
	}
]

const Dashboard = () => {
	const navigate = useNavigate()

	return (
		<Box>
			<Box margin={{ bottom: 'l' }}>
				<Header variant="h1">AWS</Header>
			</Box>
			<Cards
				items={awsCards}
				cardDefinition={{
					header: (item) => (
						<Link fontSize="heading-m" onFollow={() => navigate(item.href)}>
							{item.name}
						</Link>
					),
					sections: [
						{
							header: 'Description:',
							content: (item) => item.description
						}
					]
				}}
			></Cards>

			<Box margin={{ bottom: 'l' }}>
				<Header variant="h1">GCP</Header>
			</Box>
			<Cards
				items={gcpCards}
				cardDefinition={{
					header: (item) => (
						<Link fontSize="heading-m" onFollow={() => navigate(item.href)}>
							{item.name}
						</Link>
					),
					sections: [
						{
							header: 'Description:',
							content: (item) => item.description
						}
					]
				}}
			></Cards>

			<Box margin={{ bottom: 'l' }}>
				<Header variant="h1">RHOCP</Header>
			</Box>
			<Cards
				items={rhocpCards}
				cardDefinition={{
					header: (item) => (
						<Link fontSize="heading-m" onFollow={() => navigate(item.href)}>
							{item.name}
						</Link>
					),
					sections: [
						{
							header: 'Description:',
							content: (item) => item.description
						}
					]
				}}
			></Cards>

			<Box margin={{ bottom: 'l' }}>
				<Header variant="h1">Administration</Header>
			</Box>
			<Cards
				items={adCards}
				cardDefinition={{
					header: (item) => (
						<Link fontSize="heading-m" onFollow={() => navigate(item.href)}>
							{item.name}
						</Link>
					),
					sections: [
						{
							header: 'Description:',
							content: (item) => item.description
						}
					]
				}}
			></Cards>
		</Box>
	)
}

export default Dashboard
